/** ユーザ所属システム */
export const AUTH_SYSTEM = {
  /** 共通認証基盤 */
  DISASTER: 'DISASTER-AUTH',
  /** DUP認証基盤 */
  DUP: 'DUP-AUTH'
} as const
